var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNabox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-\\u94FE\\u63A5\\u94B1\\u5305-Solana",
    transform: "translate(-916.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(916.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4F4D\\u56FE\\u5907\\u4EFD-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#2AC98B",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-black.e910a1d2",
    transform: "translate(9.000000, 7.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 10.110021 0 26.8770147 4.85476524 29.6757183 4.85476524 17.6814996 9.69218641 20.475473 9.69218641 32.461808 14.5485284 35.2605116 14.5485284 18.4919411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0276804,8.57585844 L15.8919061,5.72512263 L21.9355291,9.26173791 L17.0744569,12.0998598 L11.0276804,8.57585844 Z M15.898213,0 L1.23458304,8.57901191 L17.0476524,17.8502102 L17.0476524,36 L21.8440785,33.2060266 L21.8440785,14.8449544 L26.6909601,12.0068325 L26.6909601,30.3521374 L31.5583392,27.4872109 L31.5583392,9.16240364 L15.898213,0 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNabox);
export default __webpack_public_path__ + "static/media/nabox.c253bdf24776df23f4e4252caeafa5fe.svg";
export { ForwardRef as ReactComponent };